import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EventService } from '../services/event.service';
import { UserData } from '../models/user-data.models';
import { ApiService } from '../services/api.service';
import { ErrorType } from '../enums/error-type.enum';

@Injectable({
  providedIn: 'root'
})
export class EditorAccessGuard implements CanActivate {
  isLoggedIn!: boolean;
  constructor(
    private event: EventService,
    private router: Router,
    private apiService: ApiService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.event.userData.subscribe((res: UserData) => {
          if(res?.editorAccess === undefined) return false;
            if (!res?.editorAccess) {
                 this.apiService.alert("You don't have Editor Access", ErrorType.Error);
                 this.router.navigate(['/']);
                 return false;
            }
           });
          return true;
  }
}
